Namespace.create("cv.Views").VueComponentView = Marionette.ItemView.extend({
  template: function () {
    return "<div class='vue-app'></div>";
  },

  events: {},

  initialize: function (options) {
    this.component = options.component;
    this.defaultArgs = options.defaultArgs;
    // If defaultArgs has a "value" we also make a "modelValue" prop
    if (this.defaultArgs && this.defaultArgs.props && this.defaultArgs.props.value) {
      this.defaultArgs.props.modelValue = this.defaultArgs.props.value;
    }
    this.dataObj = this.defaultArgs.props;

    this.listenTo(
      this,
      "set_value",
      function (key, val) {
        this.dataObj[key] = val;
      },
      this,
    );

    console.log("VueComponentView initialized");
  },

  onRender: function () {
    const el = this.$(".vue-app").get(0);
    const self = this;

    const backboneApp = createApp({
      data() {
        return { ...self.dataObj };
      },
      methods: {
        handleInput(val) {
          // Set the top-level component's value
          this.value = val;

          // Trigger to the parent
          self.trigger("value_changed", val);
        },
      },
      mounted() {
        vent.trigger("layout_root:post_show");
      },
      render() {
        if (self.defaultArgs) {
          return h(vueApp._context.components[self.component], {
            ...this.$data, // Pass props
            "onUpdate:modelValue": this.handleInput, // Handle v-model behavior
          });
        } else {
          return h(self.component);
        }
      },
    });

    // Provide router and store if needed
    // vueApp.use(window.router);
    // vueApp.use(window.store);

    backboneApp.mount(el);
  },
});
